import "./App.scss";
import Header from "./components/Header";
import Home from "./components/Home";
import AboutUs from "./components/About";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Skills from "./components/Skills";
import Languages from "./components/Languages";
import Portfolio from "./components/Portfolio";
import Publications from "./components/Publications";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { useEffect, useState } from "react";
import ClassicHeader from "./components/ClassicHeader";
import { commonConfig } from "./config/commonConfig";
import TermsAndConditions from "./components/TermsAndConditions";
import Disclaimer from "./components/Disclaimer";
import PreLoader from "./components/Preloader";
import { Tooltip } from "./components/Tooltip";
import { translations } from "./config/translations";

import { useReactToPrint } from "react-to-print";
import React,{ useRef } from "react";

function App() {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: " ",
    //pageStyle: "@page { size: A4 portrait; }",
    //onAfterPrint: () => alert('Print sucess')
  });
  const classicHeader = commonConfig.classicHeader;
  const darkTheme = commonConfig.darkTheme;

  const handleNavClick = (section) => {
    document.getElementById(section).scrollIntoView({ behavior: "smooth" });
  };

  const [scrollTopVisible, setScrollTopVisible] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const [language, setLanguage] = useState("en");
  const t = translations[language];
  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setisLoading(false);
    }, 1000);
    return () => {
      clearTimeout(loadingTimeout);
    };
  }, []);

  const checkScrollTop = () => {
    let scrollTopBtn = document.getElementById("back-to-top");

    if (scrollTopBtn) {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        setScrollTopVisible(true);
      } else {
        setScrollTopVisible(false);
      }
    }
  };

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", checkScrollTop);
  }

  return (
    <>
      <div ref = {componentRef}
        style={{ position: "relative" }}
        className={classicHeader ? "" : "side-header"}
      >
        {isLoading && <PreLoader></PreLoader>}

        <div id="main-wrapper">
          {classicHeader ? (
            <ClassicHeader
              handleNavClick={handleNavClick}
              language={language}
              setLanguage={setLanguage}
              t={t}
            ></ClassicHeader>
          ) : (
            <Header
              handleNavClick={handleNavClick}
              language={language}
              setLanguage={setLanguage}
              t={t}
            ></Header>
          )}

          <div id="content" role="main">
            <Home
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              handleNavClick={handleNavClick}
              t={t}
            ></Home>
            <AboutUs
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
              handlePrint={handlePrint}
            ></AboutUs>
            {/*<Services
              classicHeader={classicHeader}
              darkTheme={darkTheme}
          ></Services>*/}
            <Experience
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
            ></Experience>
            <Education
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
            ></Education>
            <Skills
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
            ></Skills>
            <Languages
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
            ></Languages>
            <Portfolio
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
            ></Portfolio>
            <Publications
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
            ></Publications>
            <Contact
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              t={t}
            ></Contact>
          </div>
          <Footer
            classicHeader={classicHeader}
            darkTheme={darkTheme}
            handleNavClick={handleNavClick}
            t={t}
          ></Footer>
        </div>
        {/* back to top */}
        <Tooltip text="Back to Top" placement="left">
          <span
            id="back-to-top"
            className="rounded-circle"
            style={{ display: scrollTopVisible ? "inline" : "none" }}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <i className="fa fa-chevron-up"></i>
          </span>
        </Tooltip>
        <Tooltip text="Print this out!" placement="left">
        <span
            id="print"
            className="rounded-circle"
            style={{ display: scrollTopVisible ? "inline" : "none" }}
            onClick={handlePrint}
          >
            <i className="fa fa-print"></i>
          </span>
        </Tooltip>

        <TermsAndConditions darkTheme={darkTheme}></TermsAndConditions>
        <Disclaimer darkTheme={darkTheme}></Disclaimer>
      </div>
    </>
  );
}

export default App;
